module.exports = __webpack_public_path__ + "images/Pinterest-f50195.png";